import Link from "gatsby-link";
import styled from "styled-components";
import React, { Component } from "react";
import Img from "gatsby-image";
import Flex, { FlexItem } from "styled-flex-component";
import Helmet from "react-helmet";
import { Title, CenteredFull } from "../components/Typography";
import { Heading, Text, Card, Paragraph, Strong, Pane, Dialog } from "evergreen-ui";

export default class TestimonialRoll extends Component {
	state = {
		letterDialogIsShown: false,
		letterContents: {},
		title: ""
	};

	showFullLetter = (sizes, title) => {
		this.setState({ letterDialogIsShown: true, letterContents: sizes, letterTitle: title });
	};

	render() {
		const testimonials = this.props.data.allMarkdownRemark.edges;
		const index = this.props.data.PDFtestimonies.frontmatter;

		return (
			<RollContainer>
				<Helmet title={index.title} />
				<CenteredFull>
					<Title>{index.title}</Title>
				</CenteredFull>
				<Heading marginBottom={25}>Letters of Recommendation</Heading>
				<PDFGrid>
					{index.pdfs.map(pdf => (
						<Card
							backgroundColor="white"
							key={pdf.src.id}
							onClick={() => this.showFullLetter(pdf.src.childImageSharp.sizes, pdf.title)}
							padding={10}
							elevation={1}
							hoverElevation={3}>
							<Img sizes={pdf.src.childImageSharp.sizes} />
							<Text size={500}>{pdf.title}</Text>
						</Card>
					))}
				</PDFGrid>
				<TestimonialGrid>
					{testimonials.map(testimonial => (
						<TestimonialCard appearance="tint3">
							<Heading fontFamily="Bitter" marginBottom={50} size={800}>
								{testimonial.node.frontmatter.title}
							</Heading>
							<Paragraph dangerouslySetInnerHTML={{ __html: testimonial.node.html }} />
							<Strong marginTop={25} float="right">
								{testimonial.node.frontmatter.name}
								{testimonial.node.frontmatter.location && ` • ${testimonial.node.frontmatter.location}`}
								{testimonial.node.frontmatter.date && ` • ${testimonial.node.frontmatter.date}`}
							</Strong>
						</TestimonialCard>
					))}
				</TestimonialGrid>
				<Dialog
					onCloseComplete={() => this.setState({ letterDialogIsShown: false })}
					title={this.state.letterTitle}
					hasFooter={false}
					isShown={this.state.letterDialogIsShown}>
					<Img sizes={this.state.letterContents} />
				</Dialog>
			</RollContainer>
		);
	}
}

const TestimonialCard = styled(Card)`
	padding: 3rem 4rem;
	@media screen and (max-width: 800px) {
		padding: 2rem;
	}
`;

const PDFGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, 250px);
	grid-gap: 2rem;
	text-align: center;
	margin-bottom: 4rem;

	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(auto-fill, 150px);
	}
`;

const RollContainer = styled.div`
	margin: ${100 / 24}vw auto;
	max-width: 1200px;

	blockquote {
		margin: 0;
	}

	@media screen and (max-width: 1400px) {
		padding: 0 ${100 / 24}vw;
	}

	@media screen and (max-width: 800px) {
		margin: ${100 / 24}vw auto;
	}
`;

const BlogTags = styled.div`
	display: flex;
	grid-gap: 5px;
	grid-template-columns: 1fr;
	margin: 0.5rem 0;

	strong:not(:first-child) {
		margin-left: 5px;
	}
`;

const TestimonialGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, 1fr);
	grid-gap: 25px;

	@media screen and (max-width: 600px) {
		grid-template-columns: repeat(auto-fit, 1fr);
		grid-gap: 15px;
	}
`;

const BlogFlex = Flex.extend`
	padding: 10px 25px;
`;

const BlogImage = styled(Img)`
	margin-right: 15px;
	border-radius: 10px;
`;

export const testimonialQuery = graphql`
	query AllTestimonials($id: String!) {
		PDFtestimonies: markdownRemark(id: { eq: $id }) {
			frontmatter {
				title
				pdfs {
					title
					src {
						childImageSharp {
							sizes(maxWidth: 750) {
								...GatsbyImageSharpSizes_withWebp
							}
						}
						id
					}
				}
			}
		}
		allMarkdownRemark(
			sort: { order: DESC, fields: [frontmatter___name] }
			filter: { frontmatter: { templateKey: { eq: "testimonial" } } }
		) {
			edges {
				node {
					html
					id
					frontmatter {
						name
						title
						location
						date
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/testimonials-page.jsx